import FormBuilderConfig from "../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IButtonBuilder from "../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import ITextBuilder from "../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";

export type Inputs = "idPersona";
export type Buttons = "procesar";

/**
 * Baja de app TotalPass — filtros
 * Pantalla: /total-pass/baja-app
 */
export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "idPersona",
      label: "* Id Persona",
      bts: { mCol: 4 },
      component: ITextBuilder,
      props: {
        type: "TEXT"
      }
    }
  ],
  buttons: [
    {
      name: "procesar",
      label: "Procesar baja de app",
      isSubmit: true,
      bts: { mCol: 3 },
      component: IButtonBuilder
    }
  ],
  validations: {
    idPersona: {
      required: true,
      numeric: {
        validator: (value: string) => {
          if (value == null || String(value).trim() === "") {
            return false;
          }
          return !/^\d+$/.test(String(value).trim());
        },
        message: () => "Solo se permite numérico"
      }
    }
  },
  rows: [["idPersona", "procesar"]]
};
